import { render, staticRenderFns } from "./Vitamins.vue?vue&type=template&id=5a95760a"
import script from "./Vitamins.vue?vue&type=script&lang=js"
export * from "./Vitamins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports